import React from 'react'

export const LockIcon = () => (
  <span
    className="text-muted d-inline-flex align-items-center"
    style={{ cursor: 'default' }}
    title="Price is set by the vendor and cannot be changed"
  >
    <i className="fa-regular fa-lock" style={{ fontSize: '11px' }} />
  </span>
)
